export enum RebalancingStrategy {
  VMWorkloadConsolidation = 'vm_workload_consolidation',
  NodeResourceConsolidation = 'node_resource_consolidation',
}

export enum Status {
  Healthy = 'Active',
  Unhealthy = 'Inactive',
  Maintenance = 'Maintenance',
  Error = 'Error',
  Unknown = 'Unknown',
}

export enum RebalancingFrequency {
  Default = 20,
  Aggressive = 10,
  Conservative = 30,
}

export interface AutoResourceRebalancing {
  enabled: boolean
  rebalancingStrategy: RebalancingStrategy
  rebalancingFrequencyMins: number
}

export interface VMHighAvailability {
  enabled: boolean
}

export interface Gpu {
  enabled: boolean
  mode: string
}

export interface Cpu {
  mode: string
  model: string
}

export interface CreateClusterHostGroup {
  name: string
  vmHighAvailability: VMHighAvailability
  autoResourceRebalancing: AutoResourceRebalancing
  gpu: Gpu
  cpu?: Cpu
}

export interface ClusterHostGroup {
  id?: string
  name: string
  vmHighAvailability: VMHighAvailability
  autoResourceRebalancing: AutoResourceRebalancing
  hostlist: string[]
  status: Status
  gpu?: Gpu
  cpu?: Cpu
}

export interface IClusterHostGroup extends ClusterHostGroup {
  hosts?: Array<any>
  totalUsage: {
    cpuUsage: {
      current: number
      total: number
    }
    memoryUsage: {
      current: number
      total: number
    }
    storageUsage: {
      current: number
      total: number
    }
  }
}
